export default __webpack_public_path__ + "static/media/Parallax-HUD-Targeting (TD).f48d9679.jpg";